"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _MoreVert = _interopRequireDefault(require("@mui/icons-material/MoreVert"));
var _reactAvatar = _interopRequireDefault(require("react-avatar"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid/Grid"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _Menu = _interopRequireDefault(require("@mui/material/Menu/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _theme = require("../../theme");
var _Text = _interopRequireDefault(require("../Text"));
var _styles = require("@mui/material/styles");
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable require-jsdoc */
/**
 * 
 * @param {*} props 
 * @returns 
 */
var MemberCard = function MemberCard(props) {
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  var memberStatusMap = {
    0: 'Pending',
    1: 'Active',
    2: 'Account Disabled',
    3: 'Parental Leave',
    4: 'Leave of Absence',
    5: 'Temporary Lay Off',
    6: 'Disability',
    7: 'Strike',
    8: 'Late Applicant',
    9: 'Terminated',
    10: 'Approved Leave',
    11: 'Survivor Benefits',
    12: 'Severance'
  };
  var member = props.member,
    division = props.division,
    onClick = props.onClick,
    id = props.id,
    testid = props.testid,
    whitelabel = props.whitelabel;
  var showMenu = division.access !== 'Read';
  var name = "".concat(member.firstname, " ").concat(member.lastname);
  var theme = (0, _styles.useTheme)();
  var _handleMenuClick = function _handleMenuClick(event) {
    setAnchorEl(event.currentTarget);
  };
  var _handleCloseMenu = function _handleCloseMenu() {
    setAnchorEl(null);
  };
  var _editUser = function _editUser() {
    _handleCloseMenu();
    props.onEditEmployee();
  };
  var _notifyUser = function _notifyUser() {
    _handleCloseMenu();
    props.sendNotification();
  };
  var styles = {
    cardBlock: _objectSpread(_objectSpread({}, _theme.globalStyles.cardBlock), {}, {
      '&:hover': {
        borderLeft: "".concat(theme.palette.primary.main, " solid 5px")
      }
    }),
    cardSubtitle: {
      color: _theme.colors.mainTextGrey,
      fontFamily: _theme.fonts.type.medium,
      fontSize: '12px',
      margin: '0',
      padding: '0'
    },
    cardTitle: _objectSpread(_objectSpread({}, _theme.globalStyles.cardTitle), {}, {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }),
    memberCard: _theme.globalStyles.memberCard,
    menu: {
      minWidth: '250px'
    },
    blue: {
      color: _theme.colors.brandGreen
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    alignItems: "center",
    sx: _objectSpread(_objectSpread({}, styles.cardBlock), styles.memberCard)
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 2,
    sm: 2,
    md: 1
  }, /*#__PURE__*/_react["default"].createElement(_reactAvatar["default"], {
    name: name,
    size: "40",
    textSizeRatio: 3,
    round: true,
    fgColor: theme.palette.primary.main,
    color: theme.palette.primary.light
  })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    onClick: onClick,
    item: true,
    xs: 4,
    sm: 4,
    md: 6
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "column",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    style: styles.cardTitle
  }, name), /*#__PURE__*/_react["default"].createElement("p", {
    id: id || testid,
    style: styles.cardSubtitle
  }, props.member.email))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 1,
    sm: 1,
    md: 1,
    sx: {
      textAlign: 'center'
    }
  }, props.division && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    tip: division.description,
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement("p", {
    style: styles.cardTitle
  }, division.title))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 2,
    sm: 2,
    md: 2,
    style: {
      textAlign: 'center'
    }
  }, props["class"] && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    tip: props["class"].description,
    arrow: true
  }, /*#__PURE__*/_react["default"].createElement("p", {
    style: styles.cardTitle
  }, props["class"].title))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 1,
    sm: 1,
    md: 1,
    style: {
      textAlign: 'center'
    }
  }, member.cert && member.enrollmentDate && member.status === 1 ? /*#__PURE__*/_react["default"].createElement("p", {
    style: _objectSpread(_objectSpread({}, styles.cardTitle), styles.blue)
  }, _i18n["default"].t(_tokens["default"].labels.employees.live)) : /*#__PURE__*/_react["default"].createElement("p", {
    style: styles.cardTitle
  }, localizationMaps.fromEnglish("memberStatuses", memberStatusMap[member.status]))), showMenu && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 2,
    sm: 1,
    md: 1,
    sx: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "Edit",
    onClick: _handleMenuClick,
    sx: {
      padding: "12px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_MoreVert["default"], null)), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: _handleCloseMenu,
    disableAutoFocusItem: true,
    sx: {
      minWidth: "250px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: _editUser,
    sx: styles.menu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "inherit",
    medium: true,
    display: "inline"
  }, _i18n["default"].t(_tokens["default"].buttons.edit))), props.sendNotification && /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
    onClick: _notifyUser,
    sx: styles.menu
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: "inherit",
    medium: true,
    display: "inline"
  }, _i18n["default"].t(_tokens["default"].buttons.notify))))));
};
var _default = exports["default"] = MemberCard;